import { MARQUEE_ITEMS } from "../mock";
import { Star } from "lucide-react";

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <section className="bg-black text-white py-5 overflow-hidden border-y border-black">
      <div className="flex marquee-track whitespace-nowrap">
        {items.map((item, i) => (
          <div key={i} className="flex items-center gap-8 pr-8 shrink-0">
            <span className="display text-2xl md:text-3xl font-extrabold tracking-tight">
              {item}
            </span>
            <Star size={18} className="text-[#FFE14D] fill-[#FFE14D]" />
          </div>
        ))}
      </div>
    </section>
  );
}
